import { render } from "./App.vue?vue&type=template&id=09537886"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=09537886&lang=scss"

import exportComponent from "F:\\programme\\HTML\\scavc\\manage\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__